import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
export default {
    methods: {
        // 获取园所列表api/Common/GetSchoolList
        GetSchoolList(AgentId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                AgentId: AgentId,
                pageSize: 100000
            };
            this.schoolList = []
            $http.get("api/Common/GetSchoolList", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    this.schoolList = Data
                });
            });
        },
        // 获取班级列表
        GetClassList(SchoolId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                SchoolId: SchoolId,
                pageSize: 100000
            };
            this.classList = []
            $http.get("api/Class/ZqwPlatform_GetClassList", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    this.classList = Data
                });
            });
        },


        // 获取下单家长地址GET /api/Common/GetBabyConsigneeList
        GetBabyConsigneeList(id) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                ParentId: id
            };
            this.loading = true;
            $http.get("api/Common/GetBabyConsigneeList", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.AddressList = Data;
                    if (Data.length == 0) {
                        this.ConsigneeData = this.getConsigneeData()
                    }
                    for (let i = 0; i < this.AddressList.length; i++) {
                        //IsDefault==1为默认地址
                        if (this.AddressList[i].IsDefault == 1) {
                            this.info.ConsigneeList = this.AddressList[i].ConsigneeProvinceName + '  ' + this.AddressList[i].ConsigneeCityName + '  ' + this.AddressList[i].ConsigneeAreaName + '  ' + this.AddressList[i].ConsigneeAdress
                            this.form.ReceiptInfo.ConsigneeId = this.AddressList[i].Id
                            this.ConsigneeData.Consignee = this.AddressList[i].Consignee
                            this.ConsigneeData.ConsigneeTel = this.AddressList[i].ConsigneeTel
                            this.ConsigneeData.ConsigneeArea = this.AddressList[i].ConsigneeProvinceName + ' - ' + this.AddressList[i].ConsigneeCityName + ' - ' + this.AddressList[i].ConsigneeAreaName
                            this.ConsigneeData.ConsigneeAdress = this.AddressList[i].ConsigneeAdress
                            return;
                        } else {
                            this.ConsigneeData = this.getConsigneeData()
                        }
                    }
                });
            });
        },
    }
}


// WEBPACK FOOTER //
// ./src/pages/Order/LBHomeOrder/components/orderDetails/services.js